const isDevelopment = import.meta.env.MODE === 'development';
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const config = {
  // URL base para todas las llamadas a la API
  apiUrl: API_URL,
  
  // Helper para construir URLs de API de manera consistente
  getApiUrl: (endpoint) => `${API_URL}/${endpoint.startsWith('/') ? endpoint.substring(1) : endpoint}`,
  
  // Otras configuraciones derivadas de la API_URL base
  authUrl: `${API_URL}/auth`,
  fileDownloadUrl: `${API_URL}/files`,

  // Configuraciones para integración con Slack
  slackRedirectUri: import.meta.env.VITE_SLACK_REDIRECT_URI || `${API_URL}/settings`,
  
  // Otras configuraciones específicas
  env: import.meta.env.VITE_ENV || 'development',
  isProduction: import.meta.env.MODE === 'production',
  
  // Configuración para Firebase (si se usa)
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  },

  // Configuración de límites de archivos para Knowledge Base
  fileUpload: {
    // Límites para documentos RAG (PDF, DOC, etc.)
    ragDocuments: {
      maxSizeMB: parseInt(import.meta.env.VITE_RAG_MAX_FILE_SIZE_MB) || 100,
      supportedFormats: ['pdf', 'doc', 'docx', 'txt', 'md', 'ppt', 'pptx', 'csv'],
      maxSizeBytes: (parseInt(import.meta.env.VITE_RAG_MAX_FILE_SIZE_MB) || 100) * 1024 * 1024
    },
    // Límites para archivos de datos dinámicos (Excel/CSV)
    dynamicData: {
      maxSizeMB: 50,
      supportedFormats: ['xlsx', 'xls', 'csv'],
      maxSizeBytes: 50 * 1024 * 1024
    }
  }
}; 